import {
  DOCUMENT_HISTORY,
  DOCUMENT_DATA,
  DOCUMENT_DATA_BY_ID,
  DOCUMENT_LEVEL_DATA,
  DOCUMENT_LEVEL_BY_ID,
  DISTINCT_DOCUMENT_LEVEL_DATA,
  DOCUMENT_STATUS,
  FETCH_START,
  FETCH_END,
  SEARCH_DOCUMENT_SUCESS,
  NEW_APPROVAL_DOC_DATA,
  FETCH_WORKFLOW_BY_ID_SUCCESS,
  FETCH_WORKFLOW_UPDATE_BY_ID_SUCCESS,
  QUERY_LIST_DATA,
  WORKFLOW_CONFIGURATION_LIST_SUCCESS,
} from './ActionTypes';
import axios from '../../../axios.conf';
import { toast } from 'react-toastify';
//import { ServerError } from '../../../../library/constants';
import { history } from '../../../components/Helpers';
import secureLocalStorage from 'react-secure-storage';

export const fetchStart = () => {
  return {
    type: FETCH_START,
  };
};

export const fetchEnd = () => {
  return {
    type: FETCH_END,
  };
};
export const addDocumentData = (data, id, type) => {
  return (dispatch) => {
    //dispatch(fetchStart());
    addDocumentDataAPI(data, id, type)
      .then((response) => {
        dispatch(fetchDocumentData());
        history.push('/documents');
        toast.success(response.data.response);
        toast.success(
          'Document ' + response.data.response.contract.document_id + ' Saved',
        );
      })
      .catch((error) => { });
  };
};

const addDocumentDataAPI = (data, id, type) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  var result;
  if (id) {
    if (type == 'delete')
      result = axios.delete('document/' + id, data, {
        headers: headers,
      });
    else
      result = axios.put('document/' + id, data, {
        headers: headers,
      });
  } else
    result = axios.post(
      'document?application_type=' + sessionStorage.getItem('application'),
      data,
      { headers: headers },
    );
  return result;
};

export const fetchDocumentData = (pagination, limit) => {
  return (dispatch) => {
    fetchDocumentDataAPI(pagination, limit)
      .then((response) => {
        dispatch(fetchDocumentDataSuccess(response.data.response));
      })
      .catch((error) => { });
  };
};

const fetchDocumentDataAPI = (pagination, limit) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  var result;
  result = axios.get(
    'document-list?application_type=' + sessionStorage.getItem('application'),
    { headers: headers },
  );
  return result;
};

export const fetchDocumentDataSuccess = (data) => {
  return {
    type: DOCUMENT_DATA,
    data,
  };
};

export const fetchSingleDocumentData = (id, status, isTrue) => {
  return (dispatch) => {
    fetchSingleDocumentDataAPI(id)
      .then((response) => {
        dispatch(fetchSingleDocumentDataSuccess(response.data.response));
        localStorage.setItem('loginData', sessionStorage.getItem('loginData'));
        localStorage.setItem('application', sessionStorage.getItem('application'));
        if (isTrue) {
          if (status === 'new') {
            window.open('/documents/update/' + id, '_blank', 'noopener noreferrer');
          } else if (status === 'view') {
            window.open('/documents/view/' + id, '_blank', 'noopener noreferrer');
          } else {
            history.push('/documents/submit-approval/' + id);
          }
        }
        else {
          if (status == 'new') history.push('/documents/update/' + id);
          else if (status == 'view') history.push('/documents/view/' + id);
          else history.push('/documents/submit-approval/' + id);
        }

      })
      .catch((error) => { });
  };
};

const fetchSingleDocumentDataAPI = (id) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  var result;
  result = axios.get('document/' + id, { headers: headers });
  return result;
};

export const fetchSingleDocumentDataSuccess = (data) => {
  return {
    type: DOCUMENT_DATA_BY_ID,
    data,
  };
};
export const getSearchDocumentResult = (data) => {
  return (dispatch) => {
    dispatch(fetchStart());
    getSearchDocumentResultApi(data)
      .then((response) => {
        dispatch(fetchEnd());
        if (response.data.response.length > 0) {
          dispatch(fetchDocumentDataSuccess(response.data.response));
          history.push({
            pathname: '/documents',
            state: 'searchByDocuments',
          });
        } else {
          toast.error('No records found');
        }
      })
      .catch((error) => {
        dispatch(fetchEnd());
      });
  };
};

const getSearchDocumentResultApi = (data) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  if (data.filter_fields.hasOwnProperty('duration')) {
    var result = axios.post(
      'master-data-search?table_name=document_header&application_type=' +
      sessionStorage.getItem('application') +
      '&status_duration=true',
      data,
      { headers: headers },
    );
  } else {
    var result = axios.post(
      'master-data-search?table_name=document_header',
      data,
      { headers: headers },
    );
  }
  // var result = axios.get("document-list", { params: data }, { headers: headers });
  return result;
};

export const getSearchDocumentSuccess = (data) => {
  return {
    type: SEARCH_DOCUMENT_SUCESS,
    data,
  };
};

// doc level

export const addDocumentLevels = (data, type) => {
  return (dispatch) => {
    //dispatch(fetchStart());
    addDocumentLevelsAPI(data, type)
      .then((response) => {
        history.push('/document-workflow');
        toast.success(response.data.response);
        dispatch(fetchDistinctDocumentLevels());
      })
      .catch((error) => { });
  };
};

const addDocumentLevelsAPI = (data, type) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  var result;
  // if (id){
  if (type == 'delete')
    result = axios.delete(
      'approval-workflow/bulk?functionality=' +
      data.functionality +
      '&application_type=' +
      data.application_type +
      '&workflow_name=' +
      data.workflow_name,
      {
        headers: headers,
      },
    );
  else if (type == 'update')
    result = axios.put('approval-workflow', data, {
      headers: headers,
    });
  // }
  else result = axios.post('approval-workflow', data, { headers: headers });
  return result;
};

export const fetchDocumentLevels = (data, type) => {
  return (dispatch) => {
    fetchDocumentLevelsAPI(data)
      .then((response) => {
        dispatch(fetchDocumentLevelsSuccess(response.data.response));
        if (type == 'update')
          history.push('/document-workflow/update/' + data.id);
        if (type == 'view') history.push('/document-workflow/view/' + data.id);
      })
      .catch((error) => { });
  };
};

const fetchDocumentLevelsAPI = (data) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  var result;
  result = axios.get(
    'approval-workflow?application_type=' +
    data.application_type +
    '&functionality=' +
    data.functionality +
    '&workflow_name=' +
    data.workflow_name,
    // "&primary_anchor_value=" + data.primary_anchor_value,
    { headers: headers },
  );
  return result;
};

export const fetchDocumentLevelsSuccess = (data) => {
  return {
    type: DOCUMENT_LEVEL_DATA,
    data,
  };
};

export const fetchSingleDocumentLevels = (id, type) => {
  return (dispatch) => {
    fetchSingleDocumentLevelsAPI(id)
      .then((response) => {
        dispatch(fetchSingleDocumentLevelsSuccess(response.data.response));
        if (type == 'edit') history.push('/document-workflow/update/' + id);
        //  if(type=='view')
        //  history.push('/documents/view/'+id)
      })
      .catch((error) => { });
  };
};

const fetchSingleDocumentLevelsAPI = (id) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  var result;
  result = axios.get('approval-workflow/' + id, { headers: headers });
  return result;
};

export const fetchSingleDocumentLevelsSuccess = (data) => {
  return {
    type: DOCUMENT_LEVEL_BY_ID,
    data,
  };
};

export const fetchDistinctDocumentLevels = (data) => {
  return (dispatch) => {
    dispatch(fetchStart());
    fetchDistinctDocumentLevelsAPI(data)
      .then((response) => {
        dispatch(fetchEnd());
        dispatch(fetchDistinctDocumentLevelsSuccess(response.data.response));
      })
      .catch((error) => {
        dispatch(fetchEnd());
      });
  };
};

const fetchDistinctDocumentLevelsAPI = (data) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  var result;
  if (data) {
    result = axios.post('approval-workflow/distinct-name', data, { headers: headers });
  }
  else {
    result = axios.get('approval-workflow/distinct', { headers: headers });
  }
  return result;
};

export const fetchDistinctDocumentLevelsSuccess = (data) => {
  return {
    type: DISTINCT_DOCUMENT_LEVEL_DATA,
    data,
  };
};

export const fetchDocumentStatus = (data, type) => {
  return (dispatch) => {
    fetchDocumentStatusAPI(data, type)
      .then((response) => {
        dispatch(fetchDocumentStatusSuccess(response.data.response));
      })
      .catch((error) => { });
  };
};

const fetchDocumentStatusAPI = (data, type) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  var result;
  if (type == 'SubmitForApproval') {
    result = axios.post('approval-workflow/status-desc?pending=true', data, {
      headers: headers,
    });
  } else {
    result = axios.post('approval-workflow/status-desc', data, {
      headers: headers,
    });
  }
  return result;
};

export const fetchDocumentStatusSuccess = (data) => {
  return {
    type: DOCUMENT_STATUS,
    data,
  };
};

export const fetchDocumentHistory = (data, type) => {
  return (dispatch) => {
    fetchDocumentHistoryAPI(data, type)
      .then((response) => {
        dispatch(fetchDocumentHistorySuccess(response.data.response));
      })
      .catch((error) => { });
  };
};

const fetchDocumentHistoryAPI = (data, type) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  var result;
  if (type == 'global_history')
    result = axios.post('config/object-approval-data', data, { headers: headers });
  else
    result = axios.post('history-data', data, { headers: headers });
  return result;
};

export const fetchDocumentHistorySuccess = (data) => {
  return {
    type: DOCUMENT_HISTORY,
    data,
  };
};

/**
 * Re-sends the current open step's approver email for one document.
 *
 * No reducer state: the caller only needs to know whether the mail went out, so the
 * promise is returned as-is. Note this deliberately does NOT swallow the rejection the
 * way its neighbours here do — they only dispatch into the store, whereas reporting
 * failure IS this one's contract, and swallowing would make every failure look like a
 * success. The call site catches it.
 */
export const resendApprovalEmail = (data) => {
  return () => resendApprovalEmailAPI(data);
};

const resendApprovalEmailAPI = (data) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  return axios.post('config/approval-workflow/send-approver-email', data, { headers: headers });
};

// GET - NEW APPROVAL WORKFLOW DATA
export const fetchNewApprovalWorkflowDocuments = (payload = {}) => {
  return (dispatch) => {
    dispatch(fetchStart());

    fetchNewApprovalWorkflowDocumentsAPI(payload)
      .then((response) => {
        dispatch(fetchNewApprovalWorkflowDocumentsSuccess(response.data.response));
      })
      .catch((error) => {
      })
      .finally(() => {
        dispatch(fetchEnd());
      });
  };
};
// Update API call to use payload
const fetchNewApprovalWorkflowDocumentsAPI = (payload) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };

  return axios.post('/config/approval-workflows', payload, { headers });
};



// Action Creator
export const fetchNewApprovalWorkflowDocumentsSuccess = (data) => {
  return {
    type: NEW_APPROVAL_DOC_DATA,
    data,
  };
};


// new workflow approval
export const addNewWorkflowApproval = (data, type, appType, onError) => {
  return (dispatch) => {
    dispatch(fetchStart());
    // With an onError handler the caller renders the rejection as field errors,
    // so the global toast is suppressed to avoid saying it twice.
    addNewWorkflowApprovalAPI(data, type, Boolean(onError))
      .then((response) => {
        dispatch(fetchEnd());
        toast.success("Workflow Updated successfully");
        history.push({
          pathname: '/approval-workflow',
          state: { application: appType }
        });
      })
      .catch((error) => {
        dispatch(fetchEnd());
        if (onError) onError(error);
      });
  };
};

const addNewWorkflowApprovalAPI = (data, type, suppressErrorToast = false) => {
  const config = {
    headers: {
      Authorization: secureLocalStorage.getItem('aTk'),
    },
    suppressErrorToast,
  };
  var result;
  if (type == 'edit')
    result = axios.put('config/approval-workflow', data, config);
  // }
  else result = axios.post('config/approval-workflow', data, config);
  return result;
};

// delete new workflow approval
export const deleteWorkflowById = (id, appType) => {
  return (dispatch) => {
    return deleteWorkflowByIdAPI(id)
      .then((response) => {
        toast.success("Workflow deleted successfully!"); // <-- Add this line
        dispatch(fetchNewApprovalWorkflowDocuments(appType && { application_type: appType }));
      })
      .catch((error) => {
        // Optional: toast.error("Failed to delete workflow.");
      });
  };
};

const deleteWorkflowByIdAPI = (id) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  return axios.delete(`/config/approval-workflow/${id}`, { headers });
};

// get workflow by id
export const fetchWorkflowById = (id) => {
  return (dispatch) => {
    return fetchWorkflowByIdAPI(id)
      .then((response) => {
        dispatch(fetchWorkflowByIdSuccess(response.data.response));
      })
      .catch((error) => {
        // Optionally handle error
      });
  };
};


// API function
const fetchWorkflowByIdAPI = (id) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  return axios.get(`/config/approval-workflow/${id}`, { headers });
};

export const fetchWorkflowByIdSuccess = (data) => ({
  type: FETCH_WORKFLOW_BY_ID_SUCCESS,
  payload: data,
});


export const fetchWorkflowEditbyId = (id) => {
  return (dispatch) => {
    return fetchWorkflowEditbyIdApi(id)
      .then((response) => {
        dispatch(fetchWorkflowEditbyIdSuccess(response.data.response));

      })
      .catch((error) => {
        // Optionally handle error
      });
  };
};

// API function
const fetchWorkflowEditbyIdApi = (id) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  return axios.put(`/config/approval-workflow/${id}`, { headers });
};

export const fetchWorkflowEditbyIdSuccess = (data) => ({
  type: FETCH_WORKFLOW_UPDATE_BY_ID_SUCCESS,
  payload: data,
});



export const fetchQueryListData = (category) => {
  return (dispatch) => {
    fetchQueryListDataApi()
      .then((response) => {
        dispatch(fetchQueryListDataSuccess(response.data.response));
      })
      .catch((error) => { });
  };
};

const fetchQueryListDataApi = () => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  var result;
  result = axios.get(`/sql-work-bench/category/Workflow`, { headers: headers });
  return result;
};

export const fetchQueryListDataSuccess = (data) => {
  return {
    type: QUERY_LIST_DATA,
    data,
  };
};

// get workflow config

export const getWorkflowConfiguration = (functionality, appType) => {
  return (dispatch) => {
    dispatch(fetchStart());
    getWorkflowConfigurationAPI(functionality, appType)
      .then((response) => {
        dispatch(fetchEnd());
        dispatch(getWorkflowConfigurationSuccess(response.data.response));
      })
      .catch((error) => {
        dispatch(fetchEnd());
      });
  };
};

const getWorkflowConfigurationAPI = (functionality, appType) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  var result;
  result = axios.get('config/approval-workflow/lookups?functionality=' + functionality + '&application_type=' + appType, {
    headers: headers,
  });
  return result;
};
export const getWorkflowConfigurationSuccess = (data) => {
  return {
    type: WORKFLOW_CONFIGURATION_LIST_SUCCESS,
    data,
  };
};